import api from './client';
import type { AxiosResponse } from 'axios';

// ---- Management (authenticated) ----
export const getMfaStatus = (): Promise<AxiosResponse> => api.get('/auth/mfa/status');
export const totpSetup = (): Promise<AxiosResponse> => api.post('/auth/mfa/totp/setup');
export const totpEnable = (code: string): Promise<AxiosResponse> => api.post('/auth/mfa/totp/enable', { code });
export const totpDisable = (code: string): Promise<AxiosResponse> => api.post('/auth/mfa/totp/disable', { code });
export const regenerateBackupCodes = (code: string): Promise<AxiosResponse> => api.post('/auth/mfa/backup-codes/regenerate', { code });
export const emailMfaEnableSend = (): Promise<AxiosResponse> => api.post('/auth/mfa/email/enable');
export const emailMfaConfirm = (code: string): Promise<AxiosResponse> => api.post('/auth/mfa/email/confirm', { code });
export const emailMfaDisable = (): Promise<AxiosResponse> => api.post('/auth/mfa/email/disable');

// ---- Login step-up challenge ----
export const mfaChallengeSendEmail = (mfa_token: string): Promise<AxiosResponse> =>
  api.post('/auth/mfa/challenge/send-email', { mfa_token });
export const mfaChallengeVerify = (payload: { mfa_token: string; method: string; code: string; remember_device: boolean }): Promise<AxiosResponse> =>
  api.post('/auth/mfa/challenge/verify', payload);
